import { GCLOUD_COMPONENT_SETUP } from "@p0security/integrations-gcloud-shared/constants";
import type { GcloudIntegration } from "@p0security/integrations-gcloud-shared/types";
import { rootConfig } from "@p0security/integrations-gcloud-shared/util";
import type { FrontendInstallContext } from "@p0security/integrations-installer";
import type { Instructions } from "@p0security/shared/install/types";
import { Typography } from "@p0security/ui";
import type { ReactNode } from "react";

import { installIamCommands, installIamTerraform } from "./iam";

export const orgWidePolicyInstructor = (
  context: FrontendInstallContext<GcloudIntegration>
): Instructions<ReactNode> => ({
  help: (
    <>
      Provision P0&apos;s access using{" "}
      <Typography.Link
        href={`https://console.cloud.google.com/cloudshelleditor?organizationId=${
          rootConfig(context.config).organizationId
        }&cloudshell=true`}
        target="_blank"
        rel="noopener"
      >
        Cloud Shell
      </Typography.Link>{" "}
      or Terraform:
    </>
  ),
  commands: {
    shell: [
      {
        command: installIamCommands(
          context,
          GCLOUD_COMPONENT_SETUP["org-wide-policy"],
          {
            ...rootConfig(context.config),
            type: "organization",
          }
        ),
      },
    ],
    iac: [
      {
        command: installIamTerraform(
          context,
          GCLOUD_COMPONENT_SETUP["org-wide-policy"],
          { ...rootConfig(context.config), type: "organization" }
        ),
      },
    ],
  },
});
